module.exports = __webpack_public_path__ + "img/pic04.aad8ceb7.png";